import * as EventConstants from 'constants/EventConstants';
import AppDispatcher from 'lib/Dispatcher';

export function setSelection(
  data: SelectionRestoreData | {key: string; data: {selection: SelectionRestoreData}}
): void {
  // Merge in the changes into the open protocol, client-side.
  AppDispatcher.dispatch({
    actionType: EventConstants.SELECTION_SET,
    data,
  });
}
